import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import Tab from 'fuse-ui/components/Tab';
import Tabs from 'fuse-ui/components/Tabs';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    content: {
        backgroundColor: theme.palette.background.paper,
        height: '100%',
        padding: `${theme.spacing.unit * 2}px`,
    },
} );

const CollectionTabs = ( {
    activeCollectionTabIndex,
    classes,
    collectionTabItems,
    handleSwitchCollectionTab,
    match
} ) => {
    return (
        <Tabs
            value={activeCollectionTabIndex}
            indicatorAlign="top"
            indicatorColor="primary"
            onChange={handleSwitchCollectionTab}
        >
            {
                collectionTabItems.map( collectionTab => {
                    return (
                        <Tab
                            component={Link}
                            key={collectionTab.id}
                            label={collectionTab.name}
                            to={`${match.url}${collectionTab.url}`}
                            data-automation-id={`top-navigation-${collectionTab.name}`}
                        />
                    );
                } )
            }
        </Tabs>
    );

};

CollectionTabs.propTypes = {
    activeCollectionTabIndex: PropTypes.number.isRequired,
    classes: PropTypes.object.isRequired,
    collectionTabItems: PropTypes.array.isRequired,
    handleSwitchCollectionTab: PropTypes.func.isRequired,
    match: PropTypes.shape( {
        url: PropTypes.string
    } ),
};

export default withStyles( styles )( CollectionTabs );
